var _defs, _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCoingecko = function SvgCoingecko(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1646118176879,
    className: "icon",
    viewBox: "0 0 1024 1024",
    "p-id": 2154,
    width: 200,
    height: 200,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512 0a512 512 0 1 1 0 1024A512 512 0 0 1 512 0z m0 64a448 448 0 0 0-401.728 646.592c13.312-34.304 19.904-88.128 19.904-161.28 0-200.768 181.056-347.52 351.424-274.112 0 0 67.84-41.088 124.992 41.856 37.76 28.352 141.312 48.96 171.008 62.72 22.72 10.496 120.832 48.256 57.728 156.032-97.536 28.864-198.784 87.232-285.824 44.416 0 0 31.552 60.928 267.52-17.344-20.736 27.52-51.264 59.072-94.4 95.04-140.48 117.248-167.04 253.248-171.968 300.352A448 448 0 0 0 512 64z m224 384a32 32 0 1 0 0 64 32 32 0 0 0 0-64z m-320-128a96 96 0 1 0 0 192 96 96 0 0 0 0-192z m0 32a64 64 0 1 1 0 128 64 64 0 0 1 0-128z",
    "p-id": 2155,
    fill: "#3487A1"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCoingecko, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/coingecko.4a928c64.svg";
export { ForwardRef as ReactComponent };